import { connect } from "react-redux";
import SalesforceTimelineStatusSetup from "../components/AccountSetting/Salesforce/SalesforceTimelineStatusSetting/SalesforceTimelineStatusSetup";
import { goBack, push, replace } from "react-router-redux";
import * as actions from "../redux/actions/Salesforce";
import { getUser } from "../redux/actions/AccountSetting";

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  errorMessage: state.sfdcTimelineStatusSetting.errorMessage,
  shortMessage: state.sfdcTimelineStatusSetting.shortMessage,
  successMessage: state.sfdcTimelineStatusSetting.successMessage,
  // Salesforceの設定情報のロード中かどうか
  isLoadingConfig: state.salesforce.isLoadingConfig,
  timeline_status_export_mappings_flag: state.salesforce.timeline_status_export_mappings_flag,
  // クライアントのSalesforce上のマッピング項目の候補をロード中かどうか
  isLoadingFields: state.sfdcTimelineStatusSetting.isLoadingFields,
  eventFields: state.sfdcTimelineStatusSetting.eventFields,
  expiredAccessError: state.sfdcTimelineStatusSetting.expiredAccessError,
  // マッピング保存中かどうか
  isConfiguring: state.sfdcTimelineStatusSetting.isConfiguring,
});

const mapDispatchToProps = (dispatch) => ({
  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  replace(url, state) {
    dispatch(replace(url, state));
  },

  getUserInfo() {
    dispatch(getUser(true));
  },

  getSalesforceDescribeTimelineStatusExport() {
    dispatch(actions.getSalesforceDescribeTimelineStatusExport());
  },

  getSalesforceConfig() {
    dispatch(actions.getSalesforceConfig());
  },

  postSalesforceExportMappingsTimelineStatus(data) {
    dispatch(actions.postSalesforceExportMappingsTimelineStatus(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SalesforceTimelineStatusSetup);



// WEBPACK FOOTER //
// ./src/containers/SalesforceTimelineStatusSetup.js